import { createRef } from "react";
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { InputState } from "./types";

// Separate store for the ref (doesn't need devtools)
export const useRefInputStore = create<Pick<InputState, "inputRef">>()(() => ({
  inputRef: createRef<HTMLTextAreaElement>(),
}));

// Main store without the ref (can use devtools)
export const useInputStore = create<Omit<InputState, "inputRef">>()(
  devtools(
    (set) => ({
      message: "",
      isDrafting: false,

      setMessage: (message: string) => set({ message }),
      setIsDrafting: (isDrafting: boolean) => set({ isDrafting }),
      clearInput: () => set({ message: "", isDrafting: false }),
    }),
    {
      name: "input-store",
    },
  ),
);
